const FONTS = {
  GranulaMedium: "granula-medium",
  GranulaLight: "granula-light",
  GranulaWideLight: "granula-wide-light",
  GranulaWideBold: "granula-wide-bold",
  GranulaCompactMedium: "granula-compact-medium",
  GranulaCompactLight: "granula-compact-light",
  GranulaBold: "granula-bold",
  GranulaSpatialLight: "granula-spatial-light",
  GranulaSpatialBold: "granula-spatial-bold",
  GothamBold: "gotham-bold",
  GothamBook: "gotham-book",
  GothamMedium: "gotham-medium",
  ArimoMedium: "arimo-medium",
  ArimoRegular: "arimo-regular",
  ArimoBold: "arimo-bold",
  AbcgIntoNordBold: "abcg-into-nord-bold",
  AbcgIntoNordLight: "abcg-into-nord-light",
  AbcgIntoNordRegular: "abcg-into-nord-regular",
  AbcgIntoNordMedium: "abcg-into-nord-medium",
  AbcgIntoNordSemibold: "abcg-into-nord-semibold",
};

export default FONTS;
